import React, { FC } from 'react';
import { Redirect, Route, RouteComponentProps } from 'react-router-dom';
import { isLogin } from '../../../src/Common/Utils/common_utils';
import { IExtendedRouteProps } from '../interface/Routes';

/**
 * Login route need not auth if already login redirected on mainRoute
 * @param Component
 * @param rest
 * @constructor
 */
const LoginRoute: FC<IExtendedRouteProps> = ({ component: Component, ...rest }) => {
    const userRole = localStorage.getItem('role');
    console.log("user role - ",userRole
    )
    const getPageLayout = (props: any) => {
        return  userRole==null ? <Component {...props} /> : <Redirect to="/dashboard" />

    }
    return (
        <Route
            {...rest}
            render={(props: RouteComponentProps) => getPageLayout(props)}
        >{rest.children}</Route>
    )
};


export default LoginRoute;
